module.exports = __webpack_public_path__ + "img/vippack-inactive.7929993b.svg";